import styled from 'styled-components'
import 'cloudinary-video-player/cld-video-player.min.css'

const Module3 = (props: any) => {
  return (
    <StyledComponent className=''> {/* 70 is to compensate the header space */}
      <div className='snap-section-start theme-transparent show-floating-logos relative top-[10px]' />
      {/* Tailwind that occupies full width and full height depending on screen size */}
      <div className='wrapper background-image'>
        {props.block4Heading}
      </div>
    </StyledComponent>
  )
}

const StyledComponent = styled.div`
  scroll-snap-align: start;
  overflow: hidden;
  > div.wrapper {
    height: 100vh;
  }
 
  .background-image {
    background-image: url(https://res.cloudinary.com/dqzqcuqf9/image/upload/v1744795627/mch-ab-awards/iPhone_16_-_89.png);
    
    background-repeat: repeat;
    font-family: var(--abcdfont);
    color: white;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    text-align: left;
    font-size: 2.5vh;
    line-height: 2.6vh;
    padding: 0 11%;
    background-size: cover;

    // Media query for Tablet
    @media (min-width: 768px) {
      font-size: 6.4vh;
      line-height: 5.4vh;
      padding: 0 11%;
      text-align: center;
      background-size: cover;
      background-image: url(https://res.cloudinary.com/dqzqcuqf9/image/upload/v1744795627/mch-ab-awards/iPad_Pro_11__-_72.png);
    }
 
 
    // Media query for desktop
    @media (min-width: 1024px) {
      background-position: center;
      background-image: url(https://res.cloudinary.com/dqzqcuqf9/image/upload/v1744795630/mch-ab-awards/MacBook_Pro_14__-_6.png);
    }
  }
`

// https://res.cloudinary.com/dqzqcuqf9/video/upload/v1744276011/4114797-uhd_3840_2160_25fps_zyfq8i.mp4

export default Module3